var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66552 13.3289C8.7664 13.3895 8.87438 13.4163 8.97921 13.4149C9.08403 13.4163 9.19202 13.3895 9.2929 13.3289L10.1884 12.7917C11.9446 11.7379 14.0924 11.5658 15.9939 12.3264C16.6954 12.607 17.4584 12.0904 17.4584 11.335V2.13883C17.4584 1.68296 17.1808 1.27303 16.7576 1.10372C14.3084 0.124052 11.5421 0.34571 9.28012 1.70287L8.97921 1.88344L8.67829 1.70287C6.41633 0.34571 3.64998 0.124052 1.2008 1.10372C0.777542 1.27303 0.5 1.68296 0.5 2.13883V11.335C0.5 12.0904 1.26304 12.607 1.96451 12.3264C3.86606 11.5658 6.01387 11.7379 7.77003 12.7917L8.66552 13.3289ZM1.68315 2.18523V11.1667C3.88836 10.3401 6.35404 10.5623 8.3788 11.7771L8.38764 11.7824V2.90826L8.06953 2.71741C6.13788 1.55841 3.77837 1.36253 1.68315 2.18523ZM9.57961 11.7771L9.57078 11.7824V2.90826L9.88889 2.71741C11.8206 1.55841 14.1801 1.36253 16.2753 2.18523V11.1667C14.07 10.3401 11.6044 10.5623 9.57961 11.7771Z",
    fill: "#111828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowto);
export default __webpack_public_path__ + "static/media/howto.9a207b9f08a69c391570202af991345d.svg";
export { ForwardRef as ReactComponent };